import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

export default api;

// Mashy assets — official mascot artwork
const MASHY_HERO = "https://customer-assets.emergentagent.com/job_hinglish-english/artifacts/pwwhyvpb_Gemini_Generated_Image_2e5pv02e5pv02e5p_Mashy.png";

export const MASHY = {
  splashBg: MASHY_HERO,
  happy: MASHY_HERO,
  celebrate: MASHY_HERO,
  confused: MASHY_HERO,
};
